import { youtube_url_regex } from "../consts/regex";
import {
  append_to_dom,
  catch_error,
  getPostData,
  get_user_info,
  removeEmbeds,
  set_user_data,
} from "./functions";
import axios from "axios";
import {
  validation_failed_border_color,
  validation_succcess_border_color,
} from "../consts/colors";
import "slick-carousel";

var is_url_validated = true;
var is_image_loaded = false;
var youtube_URL = "";
var comment = "";
var images = [];
var positioned_images = 0;
var image_set = 0;
var image_uploaded = 0;
var is_cooked_before = false;
var rate = 0;
var post_id = $("#post-id").attr("data-post-id");
var authors_ids = [];
var $this;
var edit_mode = false;
var swipers = [];

export function setSlick() {
  destroySlicks();
  $(".popupMenu").css("pointer-events", "all");

  if ($(".swiper-container-main").length) {
    var swiperMain = new Swiper($(".swiper-container-main").get(0), {
      paginationClickable: true,
      direction: "horizontal",
      spaceBetween: 15,

      pagination: {
        el: ".swiper-pagination-main",
        type: "bullets",
        clickable: true,
      },
      navigation: {
        nextEl: ".swiper-button-next-main",
        prevEl: ".swiper-button-prev-main",
      },

      paginationClickable: true,
    });

    swiperMain?.on("slideChangeTransitionEnd", function () {
      removeEmbeds();
    });

    swipers.push(swiperMain);
  }

  $(".swiper-slide .swiper-content .recipe-comment").each((index, element) => {
    var $cloned = $(element)
      .clone()
      .removeClass("recipe-comment")
      .css({
        display: "inline",
        width: "auto",
        visibility: "hidden",
        position: "absolute",
      })
      .appendTo("body");

    if ($cloned.height() > $(element).height()) {
      $(element).parent().append('<a class="comment-toggle">عرض المزيد</a>');
    }

    $cloned.remove();
  });

  $(".swiper-container-child").each((index, slider) => {
    var swiperChild = new Swiper(slider, {
      paginationClickable: true,
      direction: "horizontal",
      spaceBetween: 15,
      nested: true,
      pagination: {
        el: ".swiper-pagination-child",
        type: "bullets",
        clickable: true,
      },
      navigation: {
        nextEl: ".swiper-button-next-child",
        prevEl: ".swiper-button-prev-child",
      },
      paginationClickable: true,
    });

    swiperChild?.on("slideChangeTransitionEnd", function () {
      removeEmbeds();
    });

    swipers.push(swiperChild);
  });
}

export function destroySlicks() {
  swipers?.forEach((swiper) => {
    swiper?.destroy();
  });
}

//validation for the button
function is_validated() {
  if (
    comment !== "" &&
    is_url_validated &&
    is_image_loaded &&
    image_uploaded !== 0 &&
    image_uploaded == image_set
  ) {
    $("#cookedBy-submit").prop("disabled", false);
  } else {
    $("#cookedBy-submit").prop("disabled", true);
  }
}

function reset_inputs() {
  is_url_validated = true;
  is_image_loaded = false;
  youtube_URL = "";
  comment = "";
  images = [];
  positioned_images = 0;
  image_set = 0;
  image_uploaded = 0;
}

//upload Image
function upload_image(image, id, index) {
  const url = `${savedSettings.api_url}/uploadPhoto`;
  let body = {
    image: image,
    fileName: Date.now().toString(),
  };
  axios
    .post(url, body, {
      headers: {
        "x-api-key": savedSettings.x_api_key,
        contentType: "application/json; charset=utf-8",
        Authorization: ` Bearer ${
          JSON.parse(localStorage.getItem("login_result"))?.access_token
        }`,
      },
    })
    .then((res) => {
      if (index) {
        images[index] = res.data.imageURL;
      } else {
        images.push(res.data.imageURL);
        $(`#${id}`).attr("data-image", images.length - 1);
      }
      is_image_loaded = true;
      image_uploaded++;
      is_validated();
      $(`#${id}_loading_container`).css("display", "none");
      $(`#${id}_remove_container`).css("display", "block");
    })
    .catch((err) => {
      catch_error(err);
      is_image_loaded = true;
      is_validated();
    });
}

//Set image for the view and upload it
function setImage(id, new_id, file) {
  image_set++;
  is_validated();

  var index = null;
  if ($(`#${id}`).attr("data-image")) {
    index = $(`#${id}`).attr("data-image");
  }
  if (file) {
    //convert to base64
    const reader = new FileReader();
    reader.onloadend = () => {
      // use a regex to remove data url part
      const base64String = reader.result
        .replace("data:", "")
        .replace(/^.+,/, "");
      is_image_loaded = false;
      is_validated();
      upload_image(base64String, new_id, index);
    };
    reader.readAsDataURL(file);
    $(`#${new_id}_image`).css("opacity", "0");
    $(`#${new_id}_uploaded`)
      .attr("src", URL.createObjectURL(file))
      .css("opacity", "1");
    $(`#${id}`).val("");
    $(`#${new_id}_loading_container`).css("display", "block");
  } else {
    $(`#${new_id}_image`).css("opacity", "1");
  }
}
jQuery(document).ready(function ($) {
  if (
    window.location.pathname.includes("/recipe/") &&
    !window.location.pathname.endsWith("recipe/")
  ) {
    if ($("#authors_ids").data("authors-ids")) {
      authors_ids = $("#authors_ids").data("authors-ids") + "";
      authors_ids = authors_ids.split("__");
    }
  }

  $(document).on("click", "#popup-cock .popup-cock-close", function () {
    reset_inputs();
  });

  //return rate number and style rating stars
  $(document).on("click", "#cookedBy-rating img", function (e) {
    $(this).attr(
      "src",
      "/wp-content/themes/atyabtabkha/src/assets/images/svg/ico-star-full.svg"
    );
    $(this)
      .prevAll()
      .attr(
        "src",
        "/wp-content/themes/atyabtabkha/src/assets/images/svg/ico-star-full.svg"
      );
    $(this)
      .nextAll()
      .attr(
        "src",
        "/wp-content/themes/atyabtabkha/src/assets/images/svg/ico-star-large.svg"
      );
    rate = parseInt($(this).attr("data-rating")) * 2;

    let rate_body = {
      postID: `${post_id}`,
      rate: rate,
      authorUIDs: authors_ids,
    };

    const rate_url = `${savedSettings.api_url}/ratePost`;

    axios
      .post(rate_url, rate_body, {
        headers: {
          "x-api-key": savedSettings.x_api_key,
          contentType: "application/json; charset=utf-8",
          Authorization: ` Bearer ${
            JSON.parse(localStorage.getItem("login_result"))?.access_token
          }`,
        },
      })
      .then(() => {
        get_user_info(false, false, true);
        $("#first_to_rate p").css("display", "none").text("");
        $("#your_rating p").text(`تقييمك:  ${parseInt(rate / 2)}`);
      })
      .catch((err) => {
        catch_error(err);
      });
  });

  //check for link validation and update the url value
  $(document).on("change input focus", "#link-field-input", function (e) {
    youtube_URL = e.target.value;

    if (youtube_URL) {
      if (!youtube_url_regex.test(youtube_URL)) {
        $("#link_field").css("borderColor", validation_failed_border_color);
        is_url_validated = false;
        is_validated();
      } else {
        $("#link_field").css("borderColor", validation_succcess_border_color);
        is_url_validated = true;
        is_validated();
      }
    } else {
      $("#link_field").css("borderColor", validation_succcess_border_color);
      is_url_validated = true;
      is_validated();
    }
  });

  //update the comment value
  $(document).on("change input focus", "#cookedBy-comments", function (e) {
    comment = e.target.value;
    is_validated();
  });

  //listen to image change then set and upload it
  $(document).on(
    "change",
    ".cooked-by-images .add-recipe input:not(#cookbook_image)",
    function (e) {
      let file = e.target.files[0];
      let input_id = e.target.id;
      let new_id;

      if ($(`#${e.target.id}`).attr("data-image")) {
        new_id = input_id;
      } else {
        new_id = `${input_id.split("_")[0]}_${input_id.split("_")[1]}_${
          positioned_images + 1
        }`;
        if (file) {
          positioned_images++;
        }
      }

      setImage(e.target.id, new_id, file);
    }
  );

  //listen to image delete, remove it from the view and from the array and then push images to it's position
  $(document).on(
    "click",
    ".uploaded-file-delete:not('.cookbook-remove')",
    function (e) {
      let clear_id = e.target.id;
      $(`#cookedBy_image_${positioned_images}_remove_container`).css(
        "display",
        "none"
      );

      let input_id = clear_id.replace("_remove", "");

      let data_image_number = $(`#${input_id}`).attr("data-image");

      $(`#${input_id}`).val("");

      let clear_id_array_index = parseInt(input_id.slice(-1));

      images.splice(clear_id_array_index - 1, 1);

      for (
        let i = parseInt(data_image_number) + 1;
        i <= positioned_images;
        i++
      ) {
        let current_field_id =
          clear_id.replace("_remove", "").slice(0, -1) + i.toString();
        let new_field_id =
          clear_id.replace("_remove", "").slice(0, -1) + (i + 1).toString();
        $(`#${current_field_id}`).attr(
          "data-id",
          $(`#${new_field_id}`).attr("data-id")
        );
        $(`#${current_field_id}_uploaded`).attr(
          "src",
          $(`#${new_field_id}_uploaded`).attr("src")
        );
        $(`#${current_field_id}`).val($(`#${new_field_id}`).val());
      }

      let last_element_id =
        clear_id.replace("_remove", "").slice(0, -1) +
        positioned_images.toString();
      $(`#${last_element_id}_uploaded`)
        .attr("src", " ")
        .attr("data-id", " ")
        .css("opacity", 0);
      $(`#${last_element_id}`).attr("data-id", " ");

      $(`#${last_element_id}_remove_container`).css("display", "none");

      $(`#${last_element_id}_image`).css("opacity", 1);

      positioned_images--;
      image_set--;
      image_uploaded--;
      is_validated();
    }
  );

  //submit rating then cookedBy form in promise
  $(document).on("submit", "#form__cooked__by", function (e) {
    e.preventDefault();
    $("#cookedBy-submit").addClass("button--loading");

    images = images.slice(-8);
    const url = `${savedSettings.api_url}/cookedBy`;
    let id = parseInt(post_id);
    let body = {
      imageURLs: images,
      youtubeURL: youtube_URL,
      comment: comment,
      postID: id,
      authorUIDs: authors_ids,
      action: edit_mode ? "edit" : "add",
    };

    axios
      .post(url, body, {
        headers: {
          "x-api-key": savedSettings.x_api_key,
          contentType: "application/json; charset=utf-8",
          Authorization: ` Bearer ${
            JSON.parse(localStorage.getItem("login_result"))?.access_token
          }`,
        },
      })
      .then(() => {
        //~ UX Stuff
        $("#popup-cock").removeClass("is-active");
        $("#cookedBy-submit").removeClass("button--loading");
        $("#intercations-container").css("display", "block");
        $("#cooked_counter").css("display", "block");

        if (!is_cooked_before) {
          $("#cook-count").text(parseInt($("#cook-count").text()) + 1);
        }
        $("#gallery-footer-inner").css("border-radius", "0 0 1rem 1rem");
        //~ UX End

        get_user_info(false, false, true);
        $("#cooked-button-text").css("color", "#F13467");
        $("#cooked-button-image").css(
          "filter",
          "invert(63%) sepia(76%) saturate(7491%) hue-rotate(324deg) brightness(95%) contrast(98%)"
        );
        if (!is_cooked_before) {
          $("#cooked-tooltip").addClass("is-active");
          setTimeout(() => {
            $("#cooked-tooltip").removeClass("is-active");
          }, 3000);
        }
        is_cooked_before = true;
      })
      .catch((err) => {
        catch_error(err);
        $("#cookedBy-submit").removeClass("button--loading");
      });
  });

  // clear all inputs after success or closing the modal

  //check if the recipe is found on the localStorage/User_Info/cooked

  if (JSON.parse(localStorage.getItem("user_info"))?.ratings) {
    is_rated_by_me();
  }

  if (JSON.parse(localStorage.getItem("user_info"))?.cooked) {
    is_cooked_by_me();
  }

  $("#onCookedClick").on("click", function () {
    if (!JSON.parse(localStorage.getItem("login_result"))?.is_logged_in) {
      append_to_dom("popup-login-open", "popup-login", null);
      localStorage.setItem("cookby_should_open", true);
    } else {
      let can_update_data = false;
      let cooked_recipe_found = new Array();

      if (JSON.parse(localStorage.getItem("user_info"))?.cooked)
        if (
          JSON.parse(localStorage.getItem("user_info"))?.cooked[
            $("#post-id").data("post-id")
          ]
        ) {
          cooked_recipe_found = JSON.parse(localStorage.getItem("user_info"))
            ?.cooked[$("#post-id").data("post-id")];

          cooked_recipe_found = cooked_recipe_found.filter(
            (recipe) => !recipe.isApproved
          );

          if (cooked_recipe_found.length) {
            can_update_data = true;
          }
        }

      if (can_update_data) {
        set_user_data()
          .then(() => {
            append_to_dom("popup-cooked-by-open", "popup-cock", is_done_by_me);
          })
          .catch(() => {
            append_to_dom("popup-cooked-by-open", "popup-cock", is_done_by_me);
          });
      } else {
        append_to_dom("popup-cooked-by-open", "popup-cock", is_done_by_me);
      }
    }
  });

  // _______________________________________________________________________

  function setSlickAndShowDetails() {
    is_done_by_me();
    setSlick();
  }

  $(".popupMenu").on("click", function () {
    destroySlicks();

    $(".popupMenu").css("pointer-events", "none");

    let popupID = $(this).data("target").replace("#", "");
    let type = "popup-open-cooked-favorite-list";

    // TODO static RecipeID
    let postID = $("#post-id").data("post-id");
    // postID = 189237;

    let response_type = $(this).data("responsetype");

    if (!JSON.parse(localStorage.getItem("login_result"))?.is_logged_in) {
      localStorage.setItem(
        popupID.replaceAll("-", "_") + "_should_open_postID",
        postID
      );
      localStorage.setItem(
        popupID.replaceAll("-", "_") + "_should_open_response_type",
        response_type
      );
      localStorage.setItem(popupID.replaceAll("-", "_") + "_should_open", true);
      append_to_dom("popup-login-open", "popup-login", setSlick);
    } else {
      getPostData(postID, response_type)
        .then((res) => {
          append_to_dom(type, popupID, setSlickAndShowDetails, res);
        })
        .catch((err) => {
          catch_error(err);
          $(".popupMenu").css("pointer-events", "all");
        });
    }
  });

  // _______________________________________________________________________

  function is_done_by_me() {
    if (JSON.parse(localStorage.getItem("user_info"))?.ratings) {
      is_rated_by_me();
    }
    if (JSON.parse(localStorage.getItem("user_info"))?.cooked) {
      is_cooked_by_me();
    }
  }

  function set_values() {
    let index = $this[0].attributes["data-id"].value;

    let recipes = JSON.parse(localStorage.getItem("user_info")).cooked[index];

    let target = null;

    if (recipes) {
      target = JSON.parse(localStorage.getItem("user_info")).cooked[
        index
      ].filter((item) => !item.isApproved);
    }

    if (target) {
      target = target[0];

      $("#cookedBy-submit").prop("disabled", false);
      $("#cookedBy-submit").attr("disabled", false);

      if (JSON.parse(localStorage.getItem("user_info")).ratings) {
        if (JSON.parse(localStorage.getItem("user_info")).ratings[index]) {
          is_rated_by_me(
            JSON.parse(localStorage.getItem("user_info")).ratings[index]
          );
        }
      }

      let images = [];
      if (target.imageInfo) {
        images = target.imageInfo;
      } else {
        images = target.imageURLs;
      }
      set_old_values(images, target.youtubeURL, target.comment, target.postID);
    }
  }

  $(document).on("click", "#edit_cooked_recipe", function () {
    append_to_dom("popup-cooked-by-open", "popup-cock", set_values);
    $this = $(this);
  });
});

//set the responded values/localStorage values into the input tags
function set_old_values(old_images, old_url, old_comment, post__id) {
  if (
    window.location.href.includes("/recipe/") ||
    window.location.href.includes("my-cooked-recipes")
  ) {
    images = old_images;
    $("#link-field-input").val(old_url);
    $("#cookedBy-comments").val(old_comment);

    youtube_URL = old_url;
    comment = old_comment;
    if (old_images) {
      positioned_images = old_images.length;
    }
    post_id = post__id;
    is_url_validated = true;
    is_image_loaded = true;
    edit_mode = true;
    image_uploaded = old_images.length;
    image_set = old_images.length;
    for (let i in old_images) {
      let val = (parseInt(i) + 1).toString();
      $(`#cookedBy_image_${val}_uploaded`)
        .attr("src", old_images[i].toString())
        .css("opacity", "1");
      $(`#cookedBy_image_${val}_image`).css("opacity", "0");
      $(`#cookedBy_image_${val}_remove_container`).css("display", "block");
      $(`#cookedBy_image_${val}`).attr("data-image", i);
    }
  }
}

export function is_done_by_me() {
  is_rated_by_me();
  is_cooked_by_me();
}

export function is_rated_by_me(old_rate) {
  if (old_rate) {
    let rated_recipe_value = parseInt(old_rate / 2);

    rate = rated_recipe_value;
    $(`img[data-rating = '${rated_recipe_value}']`).attr(
      "src",
      "/wp-content/themes/atyabtabkha/src/assets/images/svg/ico-star-full.svg"
    );
    $(`img[data-rating = '${rated_recipe_value}']`)
      .prevAll()
      .attr(
        "src",
        "/wp-content/themes/atyabtabkha/src/assets/images/svg/ico-star-full.svg"
      );
    $(`img[data-rating = '${rated_recipe_value}']`)
      .nextAll()
      .attr(
        "src",
        "/wp-content/themes/atyabtabkha/src/assets/images/svg/ico-star-large.svg"
      );
  } else {
    let rated_recipe_value = JSON.parse(localStorage.getItem("user_info"))
      .ratings[$("#post-id").data("post-id")]
      ? parseInt(
          JSON.parse(localStorage.getItem("user_info")).ratings[
            $("#post-id").data("post-id")
          ]
        ) / 2
      : 0;

    rate = rated_recipe_value;
    $(`img[data-rating = '${rated_recipe_value}']`).attr(
      "src",
      "/wp-content/themes/atyabtabkha/src/assets/images/svg/ico-star-full.svg"
    );
    $(`img[data-rating = '${rated_recipe_value}']`)
      .prevAll()
      .attr(
        "src",
        "/wp-content/themes/atyabtabkha/src/assets/images/svg/ico-star-full.svg"
      );
    $(`img[data-rating = '${rated_recipe_value}']`)
      .nextAll()
      .attr(
        "src",
        "/wp-content/themes/atyabtabkha/src/assets/images/svg/ico-star-large.svg"
      );
  }
}

export function is_cooked_by_me() {
  if (localStorage.getItem("user_info")) {
    let cooked_recipes = JSON.parse(localStorage.getItem("user_info"))?.cooked;
    let postID = $("#post-id").data("post-id");
    let count = 0;
    let not_approved = null;

    if (cooked_recipes[postID]) {
      count = cooked_recipes[postID].filter((item) => item.isApproved).length;

      not_approved = cooked_recipes[postID].filter((item) => !item.isApproved);

      if (not_approved) {
        not_approved = not_approved[0];
      }

      $("#cooked-button-text").css("color", "#F13467");
      $("#cooked-button-image").css(
        "filter",
        "invert(63%) sepia(76%) saturate(7491%) hue-rotate(324deg) brightness(95%) contrast(98%)"
      );

      $("#intercations-container").css("display", "block");
      $("#cooked_counter").css("display", "block");
      $("#gallery-footer-inner").css("border-radius", "0 0 1rem 1rem");

      if (not_approved) {
        let images = [];
        if (not_approved.imageInfo) {
          images = not_approved.imageInfo;
        } else {
          images = not_approved.imageURLs;
        }
        set_old_values(
          images,
          not_approved.youtubeURL,
          not_approved.comment,
          postID
        );

        $("#cookedBy-submit").prop("disabled", false);
        is_url_validated = true;
        is_image_loaded = true;

        if (not_approved.imageURL) {
          image_uploaded = not_approved.imageURL.length;
          image_set = not_approved.imageURL.length;
        } else {
          image_uploaded = not_approved.imageURLs.length;
          image_set = not_approved.imageURLs.length;
        }

        if (JSON.parse(localStorage.getItem("user_info"))?.ratings) {
          is_validated();
          is_rated_by_me();
        }
      }

      if (count > 0) {
        $("#onCookedClick")
          .attr("data-content", count)
          .addClass("is-badge-visible");
      }
    }
  }
}
